var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVizCitationNetwork(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 288.839,
    height: 138.673,
    viewBox: "0 0 288.839 138.673",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 99"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 19",
    cx: 4.4977,
    cy: 4.4977,
    r: 4.4977,
    transform: "matrix(-1 0 0 1 288.839 47.5938)",
    fill: "#22D3EE",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 45",
    cx: 4.4977,
    cy: 4.4977,
    r: 4.4977,
    transform: "matrix(-1 0 0 1 239.364 89.1992)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 92",
    cx: 4.4977,
    cy: 4.4977,
    r: 4.4977,
    transform: "matrix(-1 0 0 1 115.678 102.682)",
    fill: "#0C45CC",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 63",
    cx: 4.4977,
    cy: 4.4977,
    r: 4.4977,
    transform: "matrix(-1 0 0 1 165.152 101.559)",
    fill: "#22D3EE",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 41",
    cx: 2.81106,
    cy: 2.81106,
    r: 2.81106,
    transform: "matrix(-1 0 0 1 287.152 61.0879)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 46",
    cx: 2.81106,
    cy: 2.81106,
    r: 2.81106,
    transform: "matrix(-1 0 0 1 237.678 102.691)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 93",
    cx: 2.81106,
    cy: 2.81106,
    r: 2.81106,
    transform: "matrix(-1 0 0 1 113.991 116.176)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 59",
    cx: 234.867,
    cy: 69.521,
    r: 2.81106,
    transform: "rotate(180 234.867 69.521)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 64",
    cx: 160.655,
    cy: 81.8803,
    r: 2.81106,
    transform: "rotate(180 160.655 81.8803)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 44",
    cx: 2.81106,
    cy: 2.81106,
    r: 2.81106,
    transform: "matrix(-1 0 0 1 287.152 75.7051)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 82",
    cx: 2.81106,
    cy: 2.81106,
    r: 2.81106,
    transform: "matrix(-1 0 0 1 287.152 126.305)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 47",
    cx: 2.81106,
    cy: 2.81106,
    r: 2.81106,
    transform: "matrix(-1 0 0 1 237.678 117.309)",
    fill: "#0C45CC",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 60",
    cx: 234.867,
    cy: 54.9038,
    r: 2.81106,
    transform: "rotate(180 234.867 54.9038)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 65",
    cx: 160.655,
    cy: 67.2632,
    r: 2.81106,
    transform: "rotate(180 160.655 67.2632)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 77",
    cx: 2.81106,
    cy: 2.81106,
    r: 2.81106,
    transform: "matrix(-1 0 0 1 175.834 98.1836)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 42",
    cx: 3.37327,
    cy: 3.37327,
    r: 3.37327,
    transform: "matrix(-1 0 0 1 287.715 67.834)",
    fill: "#0C45CC",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48",
    cx: 3.37327,
    cy: 3.37327,
    r: 3.37327,
    transform: "matrix(-1 0 0 1 238.24 109.438)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 94",
    cx: 3.37327,
    cy: 3.37327,
    r: 3.37327,
    transform: "matrix(-1 0 0 1 114.553 122.922)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 61",
    cx: 234.867,
    cy: 62.2127,
    r: 3.37327,
    transform: "rotate(180 234.867 62.2127)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 66",
    cx: 160.654,
    cy: 74.572,
    r: 3.37327,
    transform: "rotate(180 160.654 74.572)",
    fill: "#22D3EE",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 78",
    cx: 3.37327,
    cy: 3.37327,
    r: 3.37327,
    transform: "matrix(-1 0 0 1 176.397 90.3145)",
    fill: "#14BBFD",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 43",
    cx: 2.24885,
    cy: 2.24885,
    r: 2.24885,
    transform: "matrix(-1 0 0 1 286.59 92.5723)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 85",
    cx: 2.24885,
    cy: 2.24885,
    r: 2.24885,
    transform: "matrix(-1 0 0 1 286.59 21.7324)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 86",
    cx: 1.68664,
    cy: 1.68664,
    r: 1.68664,
    transform: "matrix(-1 0 0 1 286.027 11.6133)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49",
    cx: 2.24885,
    cy: 2.24885,
    r: 2.24885,
    transform: "matrix(-1 0 0 1 237.115 134.176)",
    fill: "#0C45CC",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 62",
    cx: 234.866,
    cy: 38.5988,
    r: 2.24885,
    transform: "rotate(180 234.866 38.5988)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 67",
    cx: 160.655,
    cy: 50.9582,
    r: 2.24885,
    transform: "rotate(180 160.655 50.9582)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 87",
    cx: 160.655,
    cy: 7.11443,
    r: 2.24885,
    transform: "rotate(180 160.655 7.11443)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 88",
    cx: 160.655,
    cy: 22.8566,
    r: 2.24885,
    transform: "rotate(180 160.655 22.8566)",
    fill: "#0C45CC",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 79",
    cx: 2.24885,
    cy: 2.24885,
    r: 2.24885,
    transform: "matrix(-1 0 0 1 175.273 115.051)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 33",
    cx: 4.4977,
    cy: 4.4977,
    r: 4.4977,
    transform: "matrix(-1 0 0 1 251.732 56.5898)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 68",
    cx: 4.4977,
    cy: 4.4977,
    r: 4.4977,
    transform: "matrix(-1 0 0 1 177.521 68.9492)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 80",
    cx: 185.392,
    cy: 112.811,
    r: 4.4977,
    transform: "rotate(180 185.392 112.811)",
    fill: "#0C45CC",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 91",
    cx: 185.391,
    cy: 127.429,
    r: 3.37327,
    transform: "rotate(180 185.391 127.429)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50",
    cx: 4.4977,
    cy: 4.4977,
    r: 4.4977,
    transform: "matrix(-1 0 0 1 202.258 98.1934)",
    fill: "#14BBFD",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 95",
    cx: 3.37327,
    cy: 3.37327,
    r: 3.37327,
    transform: "matrix(-1 0 0 1 77.4473 111.678)",
    fill: "#0C45CC",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 105",
    cx: 1.68664,
    cy: 1.68664,
    r: 1.68664,
    transform: "matrix(-1 0 0 1 75.7608 102.682)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 89",
    cx: 2.81106,
    cy: 2.81106,
    r: 2.81106,
    transform: "matrix(-1 0 0 1 200.571 52.0918)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 69",
    cx: 2.81106,
    cy: 2.81106,
    r: 2.81106,
    transform: "matrix(-1 0 0 1 126.359 110.553)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 81",
    cx: 2.24885,
    cy: 2.24885,
    r: 2.24885,
    transform: "matrix(-1 0 0 1 125.797 119.549)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51",
    cx: 4.4977,
    cy: 4.4977,
    r: 4.4977,
    transform: "matrix(-1 0 0 1 239.364 77.9531)",
    fill: "#22D3EE",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 96",
    cx: 4.4977,
    cy: 4.4977,
    r: 4.4977,
    transform: "matrix(-1 0 0 1 115.678 91.4375)",
    fill: "#22D3EE",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 70",
    cx: 2.81106,
    cy: 2.81106,
    r: 2.81106,
    transform: "matrix(-1 0 0 1 163.466 93.6875)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 34",
    cx: 4.4977,
    cy: 4.4977,
    r: 4.4977,
    transform: "matrix(-1 0 0 1 251.732 66.709)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 71",
    cx: 4.4977,
    cy: 4.4977,
    r: 4.4977,
    transform: "matrix(-1 0 0 1 177.521 79.0684)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52",
    cx: 4.4977,
    cy: 4.4977,
    r: 4.4977,
    transform: "matrix(-1 0 0 1 202.258 108.314)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 97",
    cx: 4.4977,
    cy: 4.4977,
    r: 4.4977,
    transform: "matrix(-1 0 0 1 78.5713 121.797)",
    fill: "#14BBFD",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 35",
    cx: 2.81106,
    cy: 2.81106,
    r: 2.81106,
    transform: "matrix(-1 0 0 1 262.415 59.9629)",
    fill: "#22D3EE",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 72",
    cx: 4.4977,
    cy: 4.4977,
    r: 4.4977,
    transform: "matrix(-1 0 0 1 189.89 86.9492)",
    fill: "#0C45CC",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53",
    cx: 4.4977,
    cy: 4.4977,
    r: 4.4977,
    transform: "matrix(-1 0 0 1 214.627 98.1934)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98",
    cx: 4.4977,
    cy: 4.4977,
    r: 4.4977,
    transform: "matrix(-1 0 0 1 90.9405 111.678)",
    fill: "#14BBFD",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 102",
    cx: 3.37327,
    cy: 3.37327,
    r: 3.37327,
    transform: "matrix(-1 0 0 1 89.8155 82.4434)",
    fill: "#22D3EE",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 103",
    cx: 2.24885,
    cy: 2.24885,
    r: 2.24885,
    transform: "matrix(-1 0 0 1 88.6915 13.8613)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 104",
    cx: 1.68664,
    cy: 1.68664,
    r: 1.68664,
    transform: "matrix(-1 0 0 1 88.129 50.9688)",
    fill: "#22D3EE",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 73",
    cx: 2.81106,
    cy: 2.81106,
    r: 2.81106,
    transform: "matrix(-1 0 0 1 138.729 110.553)",
    fill: "#14BBFD",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 90",
    cx: 3.37327,
    cy: 3.37327,
    r: 3.37327,
    transform: "matrix(-1 0 0 1 139.29 61.0781)",
    fill: "#22D3EE",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 36",
    cx: 4.4977,
    cy: 4.4977,
    r: 4.4977,
    transform: "matrix(-1 0 0 1 264.102 71.207)",
    fill: "#14BBFD",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 74",
    cx: 4.4977,
    cy: 4.4977,
    r: 4.4977,
    transform: "matrix(-1 0 0 1 189.89 101.566)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54",
    cx: 4.4977,
    cy: 4.4977,
    r: 4.4977,
    transform: "matrix(-1 0 0 1 214.627 112.811)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 37",
    cx: 4.4977,
    cy: 4.4977,
    r: 4.4977,
    transform: "matrix(-1 0 0 1 276.47 45.3457)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55",
    cx: 4.4977,
    cy: 4.4977,
    r: 4.4977,
    transform: "matrix(-1 0 0 1 226.995 86.9492)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99",
    cx: 4.4977,
    cy: 4.4977,
    r: 4.4977,
    transform: "matrix(-1 0 0 1 103.309 100.434)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 75",
    cx: 4.4977,
    cy: 4.4977,
    r: 4.4977,
    transform: "matrix(-1 0 0 1 152.783 99.3086)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 38",
    cx: 4.4977,
    cy: 4.4977,
    r: 4.4977,
    transform: "matrix(-1 0 0 1 276.47 56.5898)",
    fill: "#14BBFD",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56",
    cx: 4.4977,
    cy: 4.4977,
    r: 4.4977,
    transform: "matrix(-1 0 0 1 226.995 98.1934)",
    fill: "#14BBFD",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 100",
    cx: 4.4977,
    cy: 4.4977,
    r: 4.4977,
    transform: "matrix(-1 0 0 1 103.309 111.678)",
    fill: "#0C45CC",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 76",
    cx: 4.4977,
    cy: 4.4977,
    r: 4.4977,
    transform: "matrix(-1 0 0 1 152.783 110.553)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57",
    cx: 4.4977,
    cy: 4.4977,
    r: 4.4977,
    transform: "matrix(-1 0 0 1 226.995 112.811)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 40",
    cx: 3.37327,
    cy: 3.37327,
    r: 3.37327,
    transform: "matrix(-1 0 0 1 275.346 79.0781)",
    fill: "#0C45CC",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 101",
    cx: 3.37327,
    cy: 3.37327,
    r: 3.37327,
    transform: "matrix(-1 0 0 1 151.659 74.5723)",
    fill: "#22D3EE",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58",
    cx: 3.37327,
    cy: 3.37327,
    r: 3.37327,
    transform: "matrix(-1 0 0 1 225.871 120.682)",
    fill: "#0C45CC",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 84",
    cx: 1.12442,
    cy: 1.12442,
    r: 1.12442,
    transform: "matrix(-1 0 0 1 235.991 19.4844)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 63_2",
    cx: 4.4977,
    cy: 4.4977,
    r: 4.4977,
    transform: "matrix(-1 0 0 1 32.0459 85)",
    fill: "#22D3EE",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 95_2",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "matrix(-1 0 0 1 30.0479 32)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 96_2",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "matrix(-1 0 0 1 30.0479 0)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 79_2",
    cx: 2.24885,
    cy: 2.24885,
    r: 2.24885,
    transform: "matrix(-1 0 0 1 42.1661 98.4922)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 80_2",
    cx: 52.2856,
    cy: 96.2523,
    r: 4.4977,
    transform: "rotate(180 52.2856 96.2523)",
    fill: "#0C45CC",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 91_2",
    cx: 52.285,
    cy: 110.871,
    r: 3.37327,
    transform: "rotate(180 52.285 110.871)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52_2",
    cx: 4.4977,
    cy: 4.4977,
    r: 4.4977,
    transform: "matrix(-1 0 0 1 69.1514 91.7559)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 73_2",
    cx: 2.81106,
    cy: 2.81106,
    r: 2.81106,
    transform: "matrix(-1 0 0 1 5.62212 93.9941)",
    fill: "#14BBFD",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 74_2",
    cx: 4.4977,
    cy: 4.4977,
    r: 4.4977,
    transform: "matrix(-1 0 0 1 56.7833 85.0078)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 76_2",
    cx: 4.4977,
    cy: 4.4977,
    r: 4.4977,
    transform: "matrix(-1 0 0 1 19.6768 93.9941)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 106",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "matrix(-1 0 0 1 17.5762 126)",
    fill: "#1384FF",
    fillOpacity: 0.75
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVizCitationNetwork);
export default __webpack_public_path__ + "static/media/viz_citation_network.8e4031aab3dccf75504071aa6eabdf46.svg";
export { ForwardRef as ReactComponent };